export default "__VITE_ASSET__7cb94de3__"